import * as React from 'react';
import { Statistic } from 'antd';
import { hasSufficientAccuracy, TWPositionData } from '../../Service/GeolocationService';

// Default TreeForm font sizes for "GPS Accuracy" and accuracy value displayed on 2 lines
// The Camera Popup title reuses same fonts but displayed on 1 single line
export const GEOLOCATION_TITLE_FONT_SIZE = 14;
// The accuracy value itself: `main.less` brings both `.ant-statistic-content-value` and the " meters"
// suffix down to 20px, under the 24px antd gives the Statistic content.
export const GEOLOCATION_ACCURACY_VALUE_FONT_SIZE = 20;

interface GeolocationDataProps {
  coordinates?: TWPositionData;
  treeForm?: boolean;
}

export default class GeolocationData extends React.Component<GeolocationDataProps, any> {
  constructor(props: GeolocationDataProps) {
    super(props);
  }

  render() {
    const { coordinates, treeForm } = this.props;
    const accuracy = coordinates && coordinates.accuracy;

    return (
      <div style={{ marginTop: treeForm ? 0 : '10px', marginBottom: treeForm ? '20px' : '10px', width: '100%', display: 'block' }}>
        <Statistic
          title={<span style={{ fontSize: GEOLOCATION_TITLE_FONT_SIZE }}>GPS Accuracy</span>}
          value={accuracy ? Math.floor(accuracy) : 'Waiting for GPS'}
          precision={0}
          valueStyle={{ color: hasSufficientAccuracy(accuracy) ? '#3f8600' : '#cf1322' }}
          suffix={accuracy ? ` meter${Math.floor(accuracy) > 1 ? 's' : ''}` : ''}
        />
      </div>
    );
  }
}
